var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandPointing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 19.25V17.1875C28.875 16.2758 28.5128 15.4015 27.8682 14.7568C27.2235 14.1122 26.3492 13.75 25.4375 13.75C24.5258 13.75 23.6515 14.1122 23.0068 14.7568C22.3622 15.4015 22 16.2758 22 17.1875V6.1875C22 5.27582 21.6378 4.40148 20.9932 3.75682C20.3485 3.11216 19.4742 2.75 18.5625 2.75C17.6508 2.75 16.7765 3.11216 16.1318 3.75682C15.4872 4.40148 15.125 5.27582 15.125 6.1875V27.0359L11.3609 20.5047C10.9051 19.7138 10.1538 19.1364 9.27219 18.8995C8.39062 18.6626 7.45104 18.7856 6.66016 19.2414C5.86928 19.6972 5.29187 20.4486 5.05496 21.3302C4.81805 22.2117 4.94104 23.1513 5.39688 23.9422C11 35.75 14.4031 39.875 22 39.875C23.8057 39.875 25.5937 39.5193 27.2619 38.8283C28.9301 38.1373 30.4459 37.1245 31.7227 35.8477C32.9995 34.5709 34.0123 33.0551 34.7033 31.3869C35.3944 29.7187 35.75 27.9307 35.75 26.125V19.25C35.75 18.3383 35.3878 17.464 34.7432 16.8193C34.0985 16.1747 33.2242 15.8125 32.3125 15.8125C31.4008 15.8125 30.5265 16.1747 29.8818 16.8193C29.2372 17.464 28.875 18.3383 28.875 19.25V19.25Z",
    stroke: "#FCFCFC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPointing);
export default __webpack_public_path__ + "static/media/handPointing.72fe7dfe32005c7446478fcea017af58.svg";
export { ForwardRef as ReactComponent };